module.exports = __webpack_public_path__ + "static/media/modsy-logo.44c473bc.svg";